import { render } from "./forwardDisposition.vue?vue&type=template&id=00a08d44&scoped=true"
import script from "./forwardDisposition.vue?vue&type=script&lang=js"
export * from "./forwardDisposition.vue?vue&type=script&lang=js"

import "./forwardDisposition.vue?vue&type=style&index=0&id=00a08d44&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a08d44"]])

export default __exports__